import fetch, { parseListResponse } from "./fetch";

export interface AnneeInterface {
    numero_suivi: number;
    numero_etude: string;
}

class AnneeSecteur {
    all(params?: HashMap<any>) {
        return parseListResponse<AnneeInterface>(fetch.get(`annee_secteur/liste/`, { params }));
    }
}

export default new AnneeSecteur();
